<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="row  m-4 mt-0 mb-0">
      <div class="col-sm-12">
        <div class="row">

          <div class="col-sm-12">
            <div class="card card-body mb-0">
              <div class="row">

                <DatePicker :popover="{visibility: 'click'}" v-model="requestDTO.range" :model-modifiers="{string: true}" is-range mode="range"  :masks="{input: 'YYYY-MM-DD', modelValue: 'YYYY-MM-DD'}">
                  <template #default="{ inputValue, togglePopover, inputEvents }">
                    <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                      <div class="col p-0">
                        <div class="">
                          <input
                            class="form-control form-control-sm"
                            :placeholder="helper.trans('labels.from_date')"
                            :value="inputValue.start"
                            v-on="inputEvents.start"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                      <div class="col p-0">
                        <div class="">
                          <input
                            class="form-control form-control-sm"
                            :placeholder="helper.trans('labels.to_date')"
                            :value="inputValue.end"
                            v-on="inputEvents.end"
                          />
                        </div>
                      </div>
                    </div>
                  </template>
                </DatePicker>

                <div class="form-group mb-2 col">
                  <div class="col-auto p-0 text-end ">
                    <button type="button" @click.prevent="() => applyFilters()" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">{{ helper.trans('button.apply') }}</button>
                    <button type="button" @click.prevent="() => clearFilters()" class="btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first">{{ helper.trans('button.reset') }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="row m-4 mb-0 mt-0 ms-3 me-3">
      <div class="col-xs-12 col-sm-6 col-lg-4 mb-1 ps-2 pe-2">
        <div class="card card-body mb-0">
          <div class="overflow-auto">
            <div class="text-center mb-1">
              <label class="d-block text-center text-capitalize-first"><b>{{helper.trans('labels.total') }}</b></label>
            </div>
            <table  class="table table-bordered align-middle text-left text-nowrap position-relative">
              <thead>
              <tr class="bg-light">
                <th class="text-capitalize">{{ helper.trans('labels.operation')}}</th>
                <th class="text-capitalize">{{ helper.trans('labels.sum')}}</th>
                <th class="text-capitalize">{{ helper.trans('labels.count')}}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in items['total']" :key="item.operation">
                <td>{{ helper.trans(`operation_type.${item.operation}`)}}</td>
                <td>{{ numberFormatter.formatMoney(item.totalSum, 2)}}</td>
                <td>{{numberFormatter.formatNumber(item.count, 0)}}</td>
              </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>

      <div v-for="label in labels" :key="label.id" class="col-xs-12 col-sm-6 col-lg-4 mb-1 ps-2 pe-2">
        <div class="card card-body mb-0">
          <div class="overflow-auto">
            <div class="text-center mb-1">
              <label class="d-block text-center">{{label.label ?? label.id}}</label>
            </div>
            <table  class="table table-bordered align-middle text-left text-nowrap position-relative">
              <thead>
              <tr class="bg-light">
                <th class="text-capitalize">{{ helper.trans('labels.operation')}}</th>
                <th class="text-capitalize">{{ helper.trans('labels.sum')}}</th>
                <th class="text-capitalize">{{ helper.trans('labels.count')}}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in items[label.id]" :key="item.operation">
                <td>{{ helper.trans(`operation_type.${item.operation}`)}}</td>
                <td>{{ numberFormatter.formatMoney(item.totalSum, 2)}}</td>
                <td>{{numberFormatter.formatNumber(item.count, 0)}}</td>
              </tr>
              </tbody>
            </table>

          </div>

        </div>
      </div>
    </div>

  </LoaderWrapper>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {defineComponent, onMounted, toRefs, reactive, ref, ComputedRef, computed} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import {api} from "@/service/APIClient";
import {useStore} from "vuex";
import {debounce, helper} from "@/service/CommonHelper";
import {useNotification} from "@kyvg/vue3-notification";
import CopyButton from "@/components/CopyButton.vue";
import {BPagination} from "bootstrap-vue-3";
import {UserRole} from "@/models/enum/UserRole";
import {DealStatus} from "@/models/enum/DealStatus";
import {Direction} from "@/models/enum/Direction";
import {DatePicker} from "v-calendar";
import Multiselect from "vue-multiselect";
import moment from "moment";
import {Dictionary} from "@/types";
import StatisticLabelOperationsDTO from "@/models/StatisticLabelOperationsDTO";
import StatisticLabelDTO from "@/models/StatisticLabelDTO";

const notification = useNotification()

export default defineComponent({
  components: {
    DatePicker,
    Multiselect,
    LoaderWrapper,
    CopyButton,
    BPagination,
  },
  setup() {
    const defaultRequestDTO = {
      range: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
    };

    const store = useStore()
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)

    const state = reactive({
      labels: [] as StatisticLabelDTO[],
      items: {} as Dictionary<StatisticLabelOperationsDTO[]>,
      usdtSubunits: 2,
      requestDTO: {
        ...defaultRequestDTO
      } as any
    });



    const clearFilters = async () => {
      state.requestDTO = {
        ...defaultRequestDTO
      }
    }

    const load = async () => {
      loader.value?.show()
      try {
        const labels = await api.call.statistic.labels();
        let itemsByLabelId = {} as Dictionary<StatisticLabelOperationsDTO[]>
        let countByLabelId = {} as Dictionary<number>
        for (const label of labels) {
          itemsByLabelId[label.id] = []
          countByLabelId[label.id] = 0
        }

        const items = await api.call.statistic.labelsOperations({
          fromDate: state.requestDTO.range.start,
          toDate: state.requestDTO.range.end,
        });

        for (const item of items) {
          if (!itemsByLabelId[item.labelId]) {
            itemsByLabelId[item.labelId] = []
            countByLabelId[item.labelId] = 0
          }
          itemsByLabelId[item.labelId].push(item)
          countByLabelId[item.labelId] += item.count
        }

        state.items = itemsByLabelId
        state.labels = labels.sort((a,b) => {
          const aCount = countByLabelId[a.id] ?? 0;
          const bCount = countByLabelId[b.id] ?? 0;

          return aCount > bCount ? -1 : 1;
        });
      } finally {
        loader.value?.hide()
      }
    }

    const applyFilters = async () => {
      load()
    }

    onMounted(() => {
      load()
    });

    return {
      ...toRefs(state),
      user: computed(() => store.getters.getUser),
      isOperator: computed(() => store.getters.isOperator),
      isAdmin: computed(() => store.getters.isAdmin),
      isTrader: computed(() => store.getters.isTrader),
      isTeamLead: computed(() => store.getters.isTeamLead),
      isReferral: computed(() => store.getters.isReferral),
      isMerchant: computed(() => store.getters.isMerchant),
      isMerchantOperator: computed(() => store.getters.isMerchantOperator),
      loader,
      dateHelper,
      numberFormatter,
      helper,
      clearFilters,
      UserRole,
      DealStatus,
      Direction,
      applyFilters,
      store,
    }
  }
})
</script>
